export default "__VITE_ASSET__b6962a2f__"